import { ReactNode } from 'react';

type SettingsRowProps = {
  icon: ReactNode;
  label: string;
  value?: string;
  action?: ReactNode;
};

const SettingsRow = ({ icon, label, value, action }: SettingsRowProps) => (
  <div className='flex items-center gap-4 px-5 py-4'>
    <div className='flex h-9 w-9 items-center justify-center rounded-full bg-[#EEF5FF] text-[#0055FF]'>
      {icon}
    </div>
    <div className='min-w-0 flex-1'>
      <div className='text-[14px] font-semibold text-main'>{label}</div>
      {value && <div className='mt-0.5 truncate text-[12px] text-[#6B7285]'>{value}</div>}
    </div>
    {action}
  </div>
);

export default SettingsRow;
